/**
 * "Novo" badge — controle único de ONDE o pill vermelho aparece na nav.
 *
 * Por que centralizar?  O badge é um nudge de UX (não é um dashboard de
 * dados). Toda vez que lançamos algo NOVO digno de destaque, basta editar
 * as DUAS constantes abaixo: (a) qual link da nav recebe o badge e (b) a
 * data do lançamento. O badge fica aceso por 30 dias e some sozinho.
 *
 * Alvos suportados (correspondem aos ``data-testid`` da nav):
 *   - "tv"           → /tv (TV JurisTube)
 *   - "radio"        → /radio (Rádio JurisTube)
 *   - "radar"        → /radar (Radar Doutrinário / Constitucional)
 *   - "comunidade"   → /comunidade
 *   - "videos"       → /videos
 *   - "podcasts"     → /podcasts
 *   - "colunistas"   → /colunistas (Artigos)
 *   - "livraria"     → /livraria
 *   - "cursos"       → /cursos
 *   - "autores"      → /autores
 *   - "temas"        → /temas
 *   - null           → desliga o badge globalmente
 */

// Alvo atual do badge "Novo" na barra superior. Para tirar o badge,
// defina como ``null``.
export const NAV_BADGE_TARGET = "radio";

// Data do lançamento (ISO 8601, ``YYYY-MM-DD``). A partir deste dia o
// badge fica aceso por 30 dias contínuos. Para resetar o contador (ex.:
// uma reformulação visual do alvo), basta atualizar a data.
export const NAV_BADGE_LAUNCH = "2026-06-28";

const BADGE_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

/** True se hoje está dentro da janela de 30 dias do lançamento. */
function _badgeWindowOpen(now = Date.now()) {
  const launch = new Date(NAV_BADGE_LAUNCH + "T00:00:00").getTime();
  if (Number.isNaN(launch)) return false;
  return now - launch >= 0 && now - launch < BADGE_DURATION_MS;
}

/** True se o badge deve aparecer para o ``target`` informado. */
export function isNavBadgeActiveFor(target, now = Date.now()) {
  if (!NAV_BADGE_TARGET || !target) return false;
  if (target !== NAV_BADGE_TARGET) return false;
  return _badgeWindowOpen(now);
}

// ───────────────────────────────────────────────────────────────────────
// Backwards-compat: o nome ``isRadarBadgeActive`` ainda é importado em
// outros pontos do código (ex.: pages de SEO antigas). Continua válido
// — devolve true apenas quando o alvo configurado é ``radar``.
// ───────────────────────────────────────────────────────────────────────
export function isRadarBadgeActive(now = Date.now()) {
  return isNavBadgeActiveFor("radar", now);
}

// Compat: a data de lançamento do Radar era exposta por esse nome. Mantida
// como alias para o constante atual para não quebrar imports legados.
export const LATEST_RADAR_LAUNCH = NAV_BADGE_LAUNCH;
